<template>
    <div>
        <div class="modal-container has-background-petBlue">
            <div class="modal-header">
                <span class="has-text-weight-bold">{{nORe == 'e' ? '' : 'New'}} {{editingSub ? 'Subslink': 'Slink'}} {{nORe == 'e' ? 'Settings' : ''}}</span>
                <div class="delete is-large is-pulled-right" @click="doClose"></div>
            </div>

            <div class="modal-body">


            <div class="slinkContainerOpen">
               
                  
                    <span class="has-text-warning has-text-weight-bold is-size-4">&raquo;</span><div class="has-text-primary is-size-4  is-inline-block">{{slink}}{{editingSub ? ':' : ''}}</div>
                    <div class="has-text-turk  is-size-6">slink.com/<b>{{slink}}{{editingSub ? ':' : ''}}{{newName}}</b></div>&nbsp;&nbsp;

                    <div v-if="editingSub">
                        <div class="has-text-turk is-size-6"><b>Subslink:</b></div>
                        <input v-show="editingSub" id="newSubName" class="inlineInput " type="text" placeholder="enter word" v-model="newName"/>
                    </div>
                    

                    
                    <div class="top10">
                        <div class="has-text-turk is-size-6"><b>Redirect to:</b></div>
                       <div class="top5">
                            <select class="inlineSelect" @change="selectChanged" v-model="rOption">
                                <option value="1">URL</option>
                                <option value="2">Phone</option>
                                <option value="3">Email</option>
                                <option v-show="!editingSub" value="4">SlinkPage</option>
                            </select>
                            <textarea v-show="target < 4" ref="ta" id="urlTextArea" class="inlineTextArea" placeholder="enter URL" v-model="newUrl"></textarea>
                       </div>
                       <div v-if="!editingSub" class="has-text-turk is-size-6 top10"><b>Description: </b>(appears on SlinkPage)</div>
                        <input v-if="!editingSub" ref="descriptionSlink" class="inlineInput desc top5" maxlength="150" :disabled="!newLinksPage" type="text" :placeholder="newLinksPage ? 'enter description' : '--'" v-model="newSlinkDesc" :class="{'disabled' : !newLinksPage}"/><br>
                       
                        <div v-show="target == 4" class="has-text-primary top5 padSides"><b>Your slink will point directly to your SlinkPage.</b> Keep in mind that, if turned on, your SlinkPage is always avaialable at <span class="has-text-warning has-text-weight-bold">&raquo;</span><b>songwriter:links</b>,
                        regardless of where you point your slink.</div>
                    </div>

                    <div v-show="showErrMsg" class="has-text-danger">{{errMsg}}</div>

                  
                   <div v-if="editingSub">
                    <div class="topBorder">&nbsp;</div>
                        <div class="has-text-dark is-inline-block is-size-5">Show on SlinkPage:</div>
                        <div class="is-inline-block"><VueToggles class="left5"  @click="newShowInLinksPage = !newShowInLinksPage" :value="newShowInLinksPage" width="50" checkedBg="#50abc7"  checkedText="on" uncheckedText="off"/></div>
                        <div v-if="editingSub" class="has-text-turk is-size-6 top10"><b>Description: </b>(appears on SlinkPage)</div>
                        <div v-show="!linksPage && newShowInLinksPage" class="has-text-grey">Note: the SlinkPage for the slink <b>{{slink}}</b> is currently off.</div>
                   </div>
                   
                    <textarea v-if="editingSub"  ref="description" class="inlineInput desc left-5 top5 ta2rows" maxlength="150" :disabled="!newShowInLinksPage" type="text" :placeholder="newShowInLinksPage ? 'enter description' : '--'" v-model="newDescription" :class="{'disabled' : !newShowInLinksPage}"></textarea><br>
                    
                    <div v-if="!editingSub">
                        <div class="topBorder top30">&nbsp;</div>
                        <div class="has-text-dark is-inline-block is-size-5">SlinkPage:</div>
                        <div class="is-inline-block"><VueToggles class="left5"  @click="newLinksPage = !newLinksPage" :value="newLinksPage" width="50" checkedBg="#50abc7"   checkedText="on" uncheckedText="off"/></div>
                        <div class="has-text-dark top10">The SlinkPage is a landing page that lists all of this Slink's subslinks with their descriptions. It is a convienient way to publish your slink eco-system to use in a "link in bio", por example. If turned on, it can be reached at <b class="handCursor" @click="navToLinks">slink.com/{{slink}}:links</b></div>
                    </div>
                    <div v-show="!editingSub"  class="has-text-turk is-size-6 top10"><b>SlinkPage Description:</b></div>
                    <textarea v-show="!editingSub"   :disabled="!newLinksPage" class="inlineTextArea2 ta2rows " placeholder="enter description" v-model="newPageDesc" :class="{'disabled': !newLinksPage}"></textarea>

                  

                 <div class="top20">
                       <div v-if="!sure && nORe == 'e' && editingSub" class="is-inline-block"> <button class="button left-5" @click="sure = true">Delete</button></div>
                       <div v-if="!sure && nORe == 'n'" class="is-inline-block">&nbsp;</div>
                       <div v-if="sure" class="is-inline-block">
                            <span class="has-text-dark top3 is-inline-block">Sure? </span>
                            <button id="yesButt" class="button is-warning is-small" @click="deleteSub">Yes</button>&nbsp;
                            <button class="button is-small" @click="sure = false">No</button>
                       </div>
                      
                       <div class="is-inline-block is-pulled-right">
                            <button class="button right5" @click="doClose">Cancel</button>
                            <button class="button is-turk" @click="save">Save</button>
                       </div>
                      <br><br>
                 </div>
                  
                   

                </div>
                
            </div>
                <!-- <form>
                    <div>
                       <table class="is-size-3 left10" >
                           <tr>
                                <td>
                                    <span><span class="chevrons has-text-grey-light has-text-weight-bold">&raquo;</span><span class="has-text-dark">{{slink}}</span><span v-if="editingSub" class="has-text-dark">:&nbsp;</span></span>
                                </td>     
                                <td width="100%" v-if="editingSub">
                                    <input id="newSubName" type="text" class="input is-warning is-size-6 has-background-dBlue" v-model="newName" placeholder="unassigned" :disabled="bypassValidation" style="text-transform: lowercase"/> 
                                </td>    
                           </tr>   
                       </table>
                    </div>
                    <div class="top20 left10">
                        <span class="has-text-dark"><b>Redirects to:</b></span>
                        <textarea class="input is-warning has-background-dBlue"  name="url" v-model="newUrl" id="urlTextArea" placeholder="unassigned" :disabled="bypassValidation" style="text-transform: lowercase"></textarea>
                    </div>

                    <div v-if="showErrMsg" class="bottom10 left10">
                        <span class="has-text-danger">{{errMsg}}</span>
                    </div>

                    <div class="top20 left10">
                        <button  class="button is-warning" type="submit" @click.prevent="save">SAVE</button>
                        <button class="button left10"  @click.prevent="doClose">CANCEL</button>
                    </div>
                </form> -->
            </div>

            <div class="modal-footer">
                <div>

                </div>
            </div>
        </div>
  
</template>

<script>
import { ThisExpression } from 'babel-generator/lib/generators/expressions';
import { A } from 'caniuse-lite/data/agents';
import  constants  from '../STATIC/constants.js'
export default {

  props: { slink: String, name: String, url: String, callBack: Function, editingSub: Boolean, showInPage: Boolean, linksPage: Boolean, nORe: { type: String, default: 'e'}, description: String, subslinkId: String, owner: Object, slinkDesc: String, pageDesc: String},
  data: function() {
    return {
        errMsg: '',
        showErrMsg: true,
        newUrl: this.url,
        newName: this.name,
        bypassValidation: false,
        existingName: '',
        target: 1,
        newShowInLinksPage: this.showInPage,
        newLinksPage: this.linksPage,
        newDescription: this.description,
        sure: false,
        rOption: this.detectUrlType(this.url),
        newSlinkDesc: this.slinkDesc || '',
        newPageDesc: this.pageDesc || ''
    };
  },
  mounted: function() {
      var self = this;
      this.existingName = this.name

      if(this.url == `https://${process.env.HOST}/${this.slink}:links` ){
        this.target = 4
      }

      if(this.newUrl.indexOf('tel://') == 0){
        this.newUrl = this.newUrl.split('://')[1]
      } else if(this.newUrl.indexOf('mailto:') == 0){
        this.newUrl = this.newUrl.split(':')[1]
      }

      document.getElementById('urlTextArea').onkeypress = function(event){
        if(event.key.charCodeAt()==13){
            event.preventDefault();
            self.save();
        }
      }

      document.getElementById('newSubName').onkeypress = function(event){
        if(az.findInArr(constants.PREVENTEDCHRS, event.key.charCodeAt()) || event.key.charCodeAt() == 58){
            event.preventDefault();
        }
    }
  },
  methods: {
    save: function(){
        var self = this;

        if(this.editingSub){

            var arr = this.$root.$refs.routerView.subslinks
            var returnIt = false
            arr.forEach(e => {
                if(e.name == self.newName && this.newName != this.existingName && self.newName != ""){
                    self.errMsg = `The subslink "${self.newName}" is already assigned to the slink "${self.slink}". You may not have duplicate subslinks on a slink.`;
                    self.showErrMsg = true;
                    returnIt = true
                    return
                }
            })

            if(this.newName == 'links'){
                self.errMsg = `You may not use the word "links." It is reserved for the SlinkPage of your slink.`;
                self.showErrMsg = true;
                returnId = true
            }

            if(returnIt)
                return
            
            if((this.newUrl == '' || this.newName == '') && !this.bypassValidation){
                this.errMsg = 'You must provide both a subslink and a destination for the redirection.';
                this.showErrMsg = true;
                //this.bypassValidation = true;
                return
            } 

        } else if(!this.editingSub && !this.bypassValidation &&  this.target != 4){
            if(this.newUrl == '' ){
                this.errMsg = 'This slink will not redirect anywhere if you do not provide a destination for it. Click "Save" again if you still wish to proceed.';
                this.showErrMsg = true;
                this.bypassValidation = true;
                return
            }
        }

        //validate url structure and provide default http=:// if necessary
        //prevent redirect to a slink
      
        if(this.rOption == 4){

      
        } else if(this.newUrl.substring(0, 17) == "http://slink.com/" 
            || this.newUrl.substring(0, 17) == "http://slink.com/" 
            || this.newUrl.substring(0, 18) == "https://slink.com/" 
            || this.newUrl.substring(0, 10) == "slink.com/" 
            || this.newUrl.substring(0, 9) == "slink.com"
            || this.newUrl.split('slink.com').length > 1){
            this.errMsg = 'You may not redirect to another slink';
            this.showErrMsg = true;
            return
        }


        if((this.newUrl != '' && !this.bypassValidation) || this.rOption == 4 ){
            if(this.rOption == 1){

                if(az.checkEmail(this.newUrl)){
                    this.errMsg = 'Please provide a valid URL';
                    this.showErrMsg = true;
                    return
                }

                //if http, https, ftp, sftp require TLD
                if(this.newUrl.indexOf('http://') == 0 || this.newUrl.indexOf('https://') == 0 || this.newUrl.indexOf('ftp://') == 0 || this.newUrl.indexOf('sftp://') == 0){
                    var ind = this.newUrl.indexOf('://');
                    var plain
                    if(ind != -1)
                        plain = this.newUrl.substring(3 + ind)
                    else 
                        plain = this.newUrl

                    if(!az.checkURL(plain)){
                        this.errMsg = 'Please provide a valid URL';
                        this.showErrMsg = true;
                        return
                    } 
                
                } else if(this.newUrl.indexOf('tel:') == 0){
                    this.errMsg = 'To enter a phone number please select the "Phone" option from the dropdown menu.';
                    this.showErrMsg = true;
                    return

                } else if(this.newUrl.indexOf('usenet:') == 0){
                    //usenet
                } else if(this.newUrl.indexOf('mailto:') == 0){
                    this.errMsg = 'To enter an email address please select the "Email" option from the dropdown menu.';
                    this.showErrMsg = true;
                    return
                } else if(this.newUrl.split('://').length >= 2){
                    //other
                }  else if(az.checkURL(this.newUrl)){
                    this.newUrl = 'http://' + this.newUrl
                } else {
                    this.errMsg = 'You must provide a valid URL';
                    this.showErrMsg = true;
                    return
                }

            } else if(this.rOption == 2){
                if(!az.checkPhone(this.newUrl)){
                    this.errMsg = 'Please provide a valid phone number.';
                    this.showErrMsg = true;
                    return 
                } else {
                    this.newUrl = 'tel://' + this.newUrl
                }
            } else if(this.rOption == 3){
                if(!az.checkEmail(this.newUrl)){
                    this.errMsg = 'Please provide a valid email address.';
                    this.showErrMsg = true;
                    return
                } else {
                    this.newUrl = 'mailto:' + this.newUrl
                }
            } else if(this.rOption == 4){
                this.newUrl = `https://${process.env.HOST}/${this.slink}:links`
            }
        }


      

       

        this.callBack(this.newUrl, this.newName? this.newName.toLowerCase() : '', this.newShowInLinksPage, this.newDescription, this.nORe, this.newLinksPage, this.newSlinkDesc, this.newPageDesc);
        this.doClose();
        if(this.name != '' && (this.name != this.newName) && this.nORe == 'e'){
            this.$root.showModalOK({message: 'NOTE: You changed the name of this subslink. If you are using a QR code for it you must regenerate it.'})     
        }
    },
    doClose: function() {
        this.$emit("close");
    },

    selectChanged: function(o){
        this.$refs.ta.classList.remove('hideMe')
       if(o.target.value == 1){
            this.$refs.ta.placeholder = 'enter URL'
            this.target = 1
       } else if(o.target.value == 2){
            this.$refs.ta.placeholder = 'enter phone'
            this.target = 2
       } else if(o.target.value == 3){
            this.$refs.ta.placeholder = 'enter email'
            this.target = 3
       } else if(o.target.value == 4){
            this.target = 4
            //this.newUrl = `https://${process.env.HOST}/${this.slink}:links`
       }
    },

    deleteSub: function(){
        
        var self = this


        function w(d){
            az.addRemSpinner(false, 'id', 'yesButt')
            self.owner.removeFromSubslinks(self.subslinkId)
            self.doClose()
        }

        function n(){
            az.addRemSpinner(false, 'id', 'yesButt')
        }

        az.addRemSpinner(true, 'id', 'yesButt')
        this.$root.apiClient.delete(`api/account/mngslink/${this.slink}/subslinks/${this.subslinkId}`, {}, w, n)
    },

    detectUrlType: function(url){
        if(url == ''){
            return 1
        } else if(url.indexOf('mailto:') == 0){
            return  3
        } else if(url == `https://${process.env.HOST}/${this.slink}:links`){
            return 4
        } else if(url.indexOf('tel://') == 0){
            return  2
        } else {
            return 1
        }
    },

    navToLinks: function(){
        window.open(
            `https://${process.env.HOST}/${this.slink}:links`,
            '_blank' 
        );
    }

  },

  
 


  
};
</script>

<style scoped>
    .modal-container {
        max-width: 600px;
        min-height: 330px;
        border-radius: 15px;
        overflow: hidden
    }



    #urlTextArea{
        
        resize: none;
    }

  
</style>



// WEBPACK FOOTER //
// src/components/ModalEdit.vue